<template>
  <div class="animated fadeIn">
    <b-form v-on:submit.prevent.prevent="onSubmitAdmin">
       <h4 class="card-title"><b v-if="!isEditMode">Add New</b><b v-else>Edit</b> Administrator</h4>
        <progress-loader ref="progress"></progress-loader>
        <b-form-row>
          <b-col md="12">
            <div v-if="errorMsg !== null" class="alert alert-danger" v-html="errorMsg"></div>
          </b-col>
          <b-col md="6">
            <b-form-group
                  label="Name" label-for="name"
                  label-class="font-weight-bold"
                  :horizontal="true">
              <b-form-row>
                <b-col sm="6">
                  <b-form-input
                        id="firstName"
                        type="text"
                        v-model="user.firstName.value"
                        placeholder="first" /><span class="required-input-sign">*</span>
                  <div v-if="user.firstName.error !== null"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                        class="invalid-feedback d-block">{{user.firstName.error}}</div>
                </b-col>
                  <b-col sm="6">
                  <b-form-input
                      id="lastName"
                      type="text"
                      v-model="user.lastName.value"
                      placeholder="last" />
                </b-col>
              </b-form-row>
            </b-form-group>
            <b-form-group
              label="Phone"
              label-for="phone"
              label-class="font-weight-bold"
              :horizontal="true">
              <b-form-row>
                <b-col sm="6">
                  <b-form-input
                        id="phone"
                        type="text"
                        v-model="user.phone.value"/><span class="required-input-sign">*</span>
                  <div v-if="user.phone.error !== null"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                        class="invalid-feedback d-block">{{user.phone.error}}</div>
                </b-col>
              </b-form-row>
            </b-form-group>
            <b-form-group
                  label="Gender" label-for="gender"
                  label-class="font-weight-bold"
                  :horizontal="true">
              <b-form-radio-group
                    id="radios2"
                    v-model="user.gender.value">
                <b-form-radio value="male">Male</b-form-radio>
                <b-form-radio value="female">Female</b-form-radio>
              </b-form-radio-group>
              <span class="required-input-sign">*</span>
              <div v-if="user.gender.error !== null"
                    role="alert"
                    aria-live="assertive"
                    aria-atomic="true"
                    class="invalid-feedback d-block">{{user.gender.error}}</div>
            </b-form-group>
            <hr />
            <b-form-group
                  label="Authentication"
                  label-for="authentication"
                  label-class="font-weight-bold"
                  :horizontal="true">
              <b-form-group
                    label="email"
                    label-for="email"
                    :horizontal="true">
                <b-form-input
                      id="email"
                      type="text"
                      v-model="user.email.value" /><span class="required-input-sign">*</span>
                <div v-if="user.email.error !== null"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                      class="invalid-feedback d-block">{{user.email.error}}</div>
              </b-form-group>
              <b-form-group
                    v-if="!isEditMode"
                    label="password"
                    label-for="password"
                    :horizontal="true">
                <b-form-input
                      id="password"
                      type="password"
                      v-model="user.password.value" /><span class="required-input-sign">*</span>
                <div v-if="user.email.error !== null"
                      role="alert"
                      aria-live="assertive"
                      aria-atomic="true"
                      class="invalid-feedback d-block">{{user.password.error}}</div>
              </b-form-group>
            </b-form-group>
            <b-form-group
              v-if="user.relation.value !== null"
              label="Relation"
              label-for="relation"
              label-class="font-weight-bold"
              :horizontal="true">
              <b-form-row>
                <b-col sm="12">
                  <b-form-input
                        id="phone"
                        type="text"
                        v-model="user.relation.value"
                        placeholder="ex: Pal" /><span class="required-input-sign">*</span>
                  <div v-if="user.relation.error !== null"
                        role="alert"
                        aria-live="assertive"
                        aria-atomic="true"
                        class="invalid-feedback d-block">{{user.relation.error}}</div>
                </b-col>
              </b-form-row>
            </b-form-group>
          </b-col>
        </b-form-row>
        <div slot="footer">
          <b-row>
            <b-col md="6" lg="3" class="d-md-down-none">
              <b-button
                    @click="goBack()"
                    size="md"
                    variant="light"
                    class="btn-pill">
                <i class="fa fa-arrow-left"></i> Back
              </b-button>
            </b-col>
            <b-col md="6" lg="3" class="text-right">
              <b-button
                    type="reset"
                    size="md"
                    variant="danger"
                    class="btn-pill">
                <i class="fa fa-ban"></i> Reset
              </b-button>
              <b-button
                    type="submit"
                    size="md"
                    variant="primary"
                    class="btn-pill">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>
            </b-col>
          </b-row>
        </div>
    </b-form>
  </div>
</template>

<script>
import axios from 'axios'
import progressLoader from '@/views/components/progressLoader'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

export default {
  name: 'userCreate',
  components: {
    axios,
    progressLoader,
    DatePicker
  },
  data () {
    return {
      isEditMode: this.$route.params.id !== undefined,
      apiUrl: window.AppConfig.apiUrl + 'profile',
      // model form
      showLoader: false,
      errorMsg: null,
      user: {
        uuid: {
          rule: '',
          value: this.$route.params.id
        },
        firstName: {
          rule: 'required editable',
          value: null,
          error: null
        },
        lastName: {
          rule: 'editable',
          value: null,
          error: null
        },
        address: {
          rule: 'editable',
          value: null,
          error: null
        },
        phone: {
          rule: 'required editable',
          value: null,
          error: null
        },
        email: {
          rule: 'required editable',
          value: null,
          error: null
        },
        password: {
          rule: 'required',
          value: null,
          error: null
        },
        relation: {
          rule: 'editable',
          value: null,
          error: null
        },
        gender: {
          rule: 'required editable',
          value: null,
          error: null
        },
        dob: {
          rule: 'editable',
          value: null,
          error: null
        },
        role: {
          rule: 'editable',
          value: 'admin',
          error: null
        }
      }
    }
  },
  mounted () {
    this.setEmptyForm()
    this.user.dob.value = moment().format('YYYY-MM-DD')
    this.user.address.value = 'mana saje'
    if (this.isEditMode) {
      this.getDetailInfo()
    }
  },
  watch: {
    '$route.params.id': function (id) {
      this.getDetailInfo()
    }
  },
  methods: {
    onSubmitAdmin () {
      this.$refs.progress.activateProgressBar()
      // init var
      this.errorMsg = null
      let hasError = false
      let obj = Object.keys(this.user)

      // validating
      for (let i = 0; i < obj.length; i++) {
        var rule = this.user[obj[i]].rule
        if (
          (
            (
              !this.isEditMode &&
              rule.indexOf('required') !== -1
            ) ||
            (
              this.isEditMode &&
              rule.indexOf('editable') !== -1 &&
              rule.indexOf('required') !== -1
            )
          ) &&
          (this.user[obj[i]].value == null || this.user[obj[i]].value == '') // eslint-disable-line
        ) {
          this.user[obj[i]].error = 'This field is required'
          hasError = true
        } else {
          this.user[Object.keys(this.user)[i]].error = null
        }
      }
      if (hasError) {
        this.$refs.progress.deactivateProgressBar()
        this.$alertify.error('Failed! Please complete the message and submit again.')
        return false
      }

      // submit data
      let Data = {}
      for (let i = 0; i < Object.keys(this.user).length; i++) {
        const key = Object.keys(this.user)[i]
        if (key === 'dob') {
          this.user[key].value = moment(this.user[key].value).format('YYYY-MM-DD')
        }

        if (!this.isEditMode) {
          Data[key] = this.user[key].value
        } else {
          if (this.user[key].rule.indexOf('editable') !== -1) {
            Data[key] = this.user[key].value
          }
        }
      }
      if (!this.isEditMode) {
        // POST
        axios.post(this.apiUrl, Data)
          .then(response => {
            this.$refs.progress.deactivateProgressBar()
            this.setEmptyForm()
            window.setTimeout(() => {
              this.$alertify.success('User has been added!')
            }, 2000)
            window.location.href = document.URL.replace('/create', '/' + response.data.uuid)
          })
          .catch(error => {
            this.doCollectErrMessage(error)
          })
      } else {
        // PATCH
        axios.patch(this.apiUrl + '/' + this.user.uuid.value, Data)
          .then(response => {
            this.$refs.progress.deactivateProgressBar()
            window.setTimeout(() => {
              this.$alertify.success('User has been updated!')
            }, 2000)
            window.location.href = document.URL.replace('/edit', '')
          })
          .catch(error => {
            this.$refs.progress.deactivateProgressBar()
            this.doCollectErrMessage(error)
          })
      }
    },

    getDetailInfo () {
      axios.get(this.apiUrl + '/' + this.$route.params.id)
        .then(response => {
          this.user.uuid.value = response.data.uuid
          this.user.firstName.value = response.data.firstName
          this.user.lastName.value = response.data.lastName
          this.user.address.value = response.data.address
          this.user.phone.value = response.data.phone
          this.user.email.value = response.data.email
          this.user.relation.value = response.data.relation
          this.user.email.value = response.data.email
          this.user.gender.value = response.data.gender
          this.user.dob.value = response.data.dob
        })
        .catch(error => {
          this.$store.dispatch('errorMessage', error)
            .then(errMsg => {
              this.$alertify.error(errMsg)
            })
          window.history.back()
        })
    },

    setEmptyForm () {
      this.user.firstName.value = null
      this.user.lastName.value = null
      this.user.address.value = null
      this.user.phone.value = null
      this.user.email.value = null
      this.user.password.value = null
      this.user.relation.value = null
      this.user.gender.value = null
      this.user.dob.value = null
    },

    doCollectErrMessage (error) {
      this.$refs.progress.deactivateProgressBar()
      this.$alertify.error('Failed! Please complete the message and submit again.')
      this.$store.dispatch('errorMessage', error)
        .then(errMsg => {
          this.errorMsg = errMsg
        })
    },

    goBack () {
      window.goBack(this)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/settings/admin/Form.vue